export default {
  getOrgSetting: (state) => state.orgSetting,
};
